module.exports = __webpack_public_path__ + "static/media/4.906e8afe.jpg";